import { render, staticRenderFns } from "./CertifiedMaterialList.vue?vue&type=template&id=41b19da4"
import script from "./CertifiedMaterialList.vue?vue&type=script&lang=js"
export * from "./CertifiedMaterialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports